export default {
    'visit-details': 'Visit details',
    'distributed-samples': 'Distributed samples',
    'edit-activity': 'Edit Activity',
    'add-new-activity': 'Add new Activity',
    'select-activity': 'select activity',
    'activity': 'Activity',
    'visit': 'Visit',
    'double-visit': 'Double visit',
    'delete-the-activity': 'delete the activity',
}